import ReactDOM from 'react-dom';
import { usePopperTooltip } from 'react-popper-tooltip';

/**
 *
 * @param {{children:React.ReactNode,
 * text:string, disabled?:boolean,
 * placement?:import('@popperjs/core').Placement}} param0
 * @returns
 */
export default function Tooltip({
  children,
  text,
  disabled = false,
  placement = 'bottom',
}) {
  const {
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({ placement });

  return (
    <>
      <div ref={setTriggerRef}>{children}</div>
      {visible &&
        !!!disabled &&
        ReactDOM.createPortal(
          <div
            ref={setTooltipRef}
            {...getTooltipProps({
              className:
                'bg-segments-dark text-white px-2 py-1 text-segments-13px z-50 max-w-sm',
            })}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
}
